import React, { ChangeEvent, FC } from 'react';

import {
  makeStyles,
  Theme,
  FormControl,
  TextField,
  MenuItem,
} from '@material-ui/core';

import { TRestaurant } from '../../../types/ICabinetStore';
import locales from '../../../locales';
import { Employees } from '../../../entities';

const textColor = '#181F28'
const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 0, // Позволяет сжиматься
    maxWidth: '400px', // Максимальная ширина как для планшета
    flex: '1 1 auto',
    [theme.breakpoints.only('xs')]: {
      marginTop: theme.spacing(0.5), // 4px
      marginBottom: theme.spacing(0.5), // 4px
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(0.75), // 6px
      marginBottom: theme.spacing(0.75), // 6px
    },
    [theme.breakpoints.down(960)]: {
      maxWidth: '400px',
    },
    [theme.breakpoints.down(750)]: {
      maxWidth: '300px',
    },
    [theme.breakpoints.down(600)]: {
      maxWidth: '200px',
    },
    [theme.breakpoints.down(480)]: {
      maxWidth: '150px',
    },

    '& svg': {
      color: textColor,
    },
  },

  label: {
    color: textColor,
    width: '100%',
    fontSize: 14,
    [theme.breakpoints.only('sm')]: {
      fontSize: 15,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
  },

  input: {
    color: textColor,
    fontWeight: 500,
    minWidth: 0, // Позволяет сжиматься
    fontSize: 14,
    [theme.breakpoints.only('sm')]: {
      fontSize: 15,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },

    '&:before': {
      borderBottomColor: textColor,
    },

    '&:after': {
      borderBottomColor: textColor,
    },

    '& .MuiSelect-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },

  list: {
    '& li': {
      color: textColor,
    },

    '& li:last-child': {
      color: textColor,
    },

    '& li.Mui-selected': {
      backgroundColor: `#F0F1F4 !important`,
      color: textColor,
    },

    '& li:hover': {
      backgroundColor: `#F0F1F4 !important`,
      color: textColor,
    },

    backgroundColor: '#FFF',
  },
}));


const RestaurantSelect: FC<{
  setCurrentRestaurant: (id: number) => void;
  currentRestaurant?: TRestaurant;
  restaurantList: Array<TRestaurant>;
  onCreateRestaurant: () => void;
}> = ({
  setCurrentRestaurant,
  restaurantList,
  currentRestaurant,
  onCreateRestaurant,
}) => {
  const { data: currentEmployee } = Employees.useCurrentEmployee();

  const onChange = (e: ChangeEvent<{ name?: string; value: any }>) => {
    if (e.target.value) {
      setCurrentRestaurant(parseInt(e.target.value, 10));
    }
  };

  const classes = useStyles();

  return (
    <FormControl fullWidth classes={{ root: classes.formControl }}>
      <TextField
        value={currentRestaurant && currentRestaurant.id}
        onChange={onChange}
        select
        id="select-restaurant"
        label={locales.t('places.restaurantSelect')}
        InputLabelProps={{ classes: { root: classes.label } }}
        InputProps={{ classes: { root: classes.input } }}
        fullWidth
        SelectProps={{
          MenuProps: {
            classes: {
              list: classes.list,
            },
            getContentAnchorEl: null,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          },
        }}
      >
        {restaurantList.map(item => (
          <MenuItem key={item.id} value={item.id}>
            {`${item.name} — ${item.address.street}, ${item.address.home}`}
          </MenuItem>
        ))}

        {currentEmployee && Employees.hasAccess(currentEmployee, 'restaurants:access') && (
          <MenuItem onClick={onCreateRestaurant}>
            {locales.t('places.restaurantAdd')}
          </MenuItem>
        )}
      </TextField>
    </FormControl>
  );
};

export default RestaurantSelect;
